import React from 'react';

function TextItalicIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeWidth='1.5'
				d='M12 4h7M8 20l8-16M5 20h7'
			></path>
		</svg>
	);
}

export default TextItalicIcon;
